/**
 * Haversine road-distance driving time estimate (fallback when Distance Matrix unavailable).
 */

export function haversineMiles(lat1: number, lng1: number, lat2: number, lng2: number): number {
  const R = 3959;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLng = ((lng2 - lng1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

/** Rough driving duration from coordinates (~28 mph effective suburban speed). */
export function estimateDrivingSecondsFromCoords(
  originLat: number,
  originLng: number,
  destLat: number,
  destLng: number,
): number {
  const roadMiles = haversineMiles(originLat, originLng, destLat, destLng) * 1.25;
  const hours = roadMiles / 28;
  return Math.max(60, Math.round(hours * 3600));
}

export function formatMatrixLocation(
  address: string,
  lat?: number,
  lng?: number,
): string {
  if (lat != null && lng != null && Number.isFinite(lat) && Number.isFinite(lng)) {
    return `${lat},${lng}`;
  }
  return address.trim();
}
